"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputSource = Object.freeze({
    URL: 'Url',
    POSTMESSAGE: 'PostMessage',
    COOKIES: 'Cookies'
});
exports.default = InputSource;
